import React, { useState } from 'react';
import styles from './IdeasScene.module.scss';
import { useSetCurrentSection } from "../../../hooks/useSetCurrentSection";
import { PAGE_SUBSECTIONS } from "../../../constants/pageTypes";
import Breadcrumbs from "../../../components/Breadcrumbs";
import Input from "../../../components/common/Input";
import ProfileButton from "../../../components/Profile/ProfileButton";
import {useDispatch} from "react-redux";
import {sendProfileIdeas} from "../../../redux/modules/profile/profile-actions";

const breadcrumbsRoutes = [{
    name: 'Личный кабинет',
    href: '#'
}, {
    name: 'Предложение идей',
    href: '/profile/ideas'
}];

const IDEAS_STAGE = {
    FORM: 'FORM',
    RESULT: 'RESULT',
};

const IdeasScene = () => {
    useSetCurrentSection(PAGE_SUBSECTIONS.IDEAS);

    const [stage, setStage] = useState(IDEAS_STAGE.FORM);

    const [form, setForm] = useState({});
    const createChangeListener = (name) => (e) => {
        setForm({ ...form, [name]: e.target.value });
    };
    const dispatch = useDispatch();

    const onSubmitForm = () => {
        dispatch(sendProfileIdeas(form));
        setForm({});
        setStage(IDEAS_STAGE.RESULT);
    };

    const onOpenForm = () => {
        setStage(IDEAS_STAGE.FORM);
    };

    return (
        <div className={styles.container}>
            <Breadcrumbs routes={breadcrumbsRoutes}/>
            <div className={styles.pageContainer}>
                {stage === IDEAS_STAGE.FORM && <div className={styles.formContainer}>
                    <div className={styles.formElementLabel}>
                        Текст сообщения
                    </div>
                    <Input name="text"
                           type="textarea"
                           className={styles.textareaContainer}
                           inputClassName={styles.textarea}
                           onChange={createChangeListener('message')} />
                    <ProfileButton primary fullWidth onClick={onSubmitForm}>
                        Отправить
                    </ProfileButton>
                </div>}
                {stage === IDEAS_STAGE.RESULT && <div className={styles.resultContainer}>
                    <div className={styles.resultTitle}>
                        Мы получили вашу отличную идею
                    </div>
                    <div className={styles.resultDesc}>
                        Рассмотрим её в ближайшее время.
                    </div>
                    <div className={styles.resultButtons}>
                        <ProfileButton onClick={onOpenForm} fullWidth>
                            Назад
                        </ProfileButton>
                    </div>
                </div>}
            </div>
        </div>
    );
};

export default IdeasScene;
